// import { resolve } from 'path'
import {
  setToken
} from '@/utils/auth.js'
import {
  loginApi,
  getUserName,
  getMenus
} from '@/api/login'
import {
  getUserInfo
} from '@/api/identity'
import config from '@/utils/config'
const login = {
  state: {
    username: '',
    breadcrumblist: '', // 面包屑集合
    menuList: [],
    logo: '',
    client: null // 商户标识
  },
  mutations: {
    SET_USERNAME (state, val) {
      state.username = val
    },
    SET_BREADCRUMBLIST (state, val) {
      state.breadcrumblist = val
    },
    SET_MENULIST (state, val) {
      state.menuList = val
    },
    SET_LOGO (state, val) {
      state.logo = val
    },
    SET_CLIENT (state, val) {
      state.client = val
    }
  },
  actions: {
    getUserNameAsync ({
      commit
    }, {
      username,
      password,
      sysId
    }) {
      return new Promise((resolve, reject) => {
        // 获取token
        loginApi(username, password, sysId).then(res => {
          if (res.success) {
            // 存储token
            setToken(res.data)
            // 获取用户信息 用户名等
            getUserName(res.data).then(res => {
              localStorage.setItem('username', res.data.username)
              localStorage.setItem('userId', res.data.id)

              commit('SET_USERNAME', res.data.username)
              resolve(res)
            }).catch(err => {
              console.log(err)
              reject(err)
            })
          }
        }).catch(err => {
          console.log(err)
          reject(err)
        })
      })
    },
    // 根据token获取用户详情。
    tokenTOusername ({
      commit
    }, {
      token
    }) {
      return new Promise((resolve, reject) => {
        getUserName(token).then(res => {
          localStorage.setItem('username', res.data.username)
          localStorage.setItem('userId', res.data.id)
          commit('SET_USERNAME', res.data.username)
          resolve(res)
        }).catch(err => {
          console.log(err)
          reject(err)
        })
      })
    },
    // 获取菜单权限
    getmenusAsync ({
      commit
    }) {
      return new Promise((resolve, reject) => {
        getMenus(config.sysid).then(res => {
          if (res.success) {
            if (!res.data) res.data = []
            resolve(res.data)
          } else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 获取商户id
    getUserInfoApi () {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    async getmenu ({
      dispatch,
      commit
    }) {
      let userinfo = await dispatch('getUserInfoApi')
      localStorage.setItem('commercialId', userinfo.id)

      localStorage.setItem('userName', userinfo.userName)
      let menulist = await dispatch('getmenusAsync')
      return menulist
    }
  }
}

export default login



// WEBPACK FOOTER //
// ./src/store/modules/login.js